export default __webpack_public_path__ + "static/founders-f7513568cb61a40cc761db519fb62b32.gif";